import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const AppComingSoon = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="app-coming-soon py-5 bg-white min-vh-100 d-flex align-items-center">
            <div className="container">
                <div className="row align-items-center g-5">
                    <div className="col-lg-6">
                        <span className="badge bg-primary-subtle text-primary px-3 py-2 rounded-pill fw-bold mb-3">
                            <i className="las la-mobile-alt me-2"></i> Future Horizon
                        </span>
                        <h1 className="display-4 fw-bold mb-4">
                            Security in Your Pocket. <br />
                            <span className="text-primary">Secure360 Mobile arrives 2026.</span>
                        </h1>
                        <p className="lead text-muted mb-5">
                            We are currently engineering a revolutionary mobile experience that brings real-time
                            security monitoring, instant push-alert remediation, and biometric-secured
                            dashboard access to your iOS and Android devices.
                        </p>

                        <div className="card border-0 bg-light rounded-4 p-4 mb-5 shadow-sm">
                            <h5 className="fw-bold mb-3">Early Features Preview:</h5>
                            <ul className="list-unstyled mb-0">
                                <li className="mb-3 d-flex align-items-start">
                                    <i className="las la-bell text-primary fs-4 me-3"></i>
                                    <div>
                                        <p className="fw-bold mb-0">Critical Push Notifications</p>
                                        <p className="small text-muted mb-0">Get notified instantly of SSL failures or high-traffic DoS attempts.</p>
                                    </div>
                                </li>
                                <li className="mb-3 d-flex align-items-start">
                                    <i className="las la-fingerprint text-primary fs-4 me-3"></i>
                                    <div>
                                        <p className="fw-bold mb-0">Biometric Security</p>
                                        <p className="small text-muted mb-0">Secure your dashboard with FaceID or Fingerprint authentication.</p>
                                    </div>
                                </li>
                                <li className="d-flex align-items-start">
                                    <i className="las la-rocket text-primary fs-4 me-3"></i>
                                    <div>
                                        <p className="fw-bold mb-0">One-Tap Remediation</p>
                                        <p className="small text-muted mb-0">Deploy urgent security fixes directly from your lock screen.</p>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <div className="d-flex gap-3">
                            <Link to="/register" className="btn btn-primary btn-lg px-5 rounded-pill shadow-sm">
                                Join Beta Waitlist
                            </Link>
                            <Link to="/roadmap" className="btn btn-outline-dark btn-lg px-4 rounded-pill">
                                View Roadmap
                            </Link>
                        </div>
                    </div>
                    <div className="col-lg-6 text-center">
                        <div className="position-relative d-inline-block">
                            <div className="bg-primary rounded-circle position-absolute top-50 start-50 translate-middle w-100 h-100 opacity-10 blur-3xl"></div>
                            <img
                                src="/assets/images/mobile-app-mockup.jpg"
                                alt="Secure360 Mobile App Mockup"
                                className="img-fluid rounded-4 shadow-2xl position-relative z-1 max-h-[600px]"
                            />
                            <div className="position-absolute bottom-0 start-0 mb-n4 ms-n4 bg-white p-4 shadow-lg rounded-4 animate-float d-none d-md-block max-w-[200px]">
                                <div className="d-flex align-items-center mb-2">
                                    <div className="bg-success rounded-circle me-2 w-[8px] h-[8px]"></div>
                                    <span className="small fw-bold">Live Monitoring</span>
                                </div>
                                <div className="h4 fw-bold mb-0">99.9%</div>
                                <p className="small text-muted mb-0">System Uptime</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <style>{`
                .shadow-2xl {
                    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
                }
                .animate-float {
                    animation: float 6s ease-in-out infinite;
                }
                @keyframes float {
                    0% { transform: translateY(0px); }
                    50% { transform: translateY(-20px); }
                    100% { transform: translateY(0px); }
                }
            `}</style>
        </div>
    );
};

export default AppComingSoon;
